import { useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TransText from "../../translation/trans_tag";
import { IoAlert, IoManOutline, IoPeopleOutline } from "react-icons/io5";
import { BsCardChecklist } from "react-icons/bs";
import { RiHealthBookLine, RiMentalHealthLine } from "react-icons/ri";
import { FaUserMd, FaBookMedical } from "react-icons/fa";
import { VscTools } from "react-icons/vsc";
import { LuCheckCheck } from "react-icons/lu";
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { CaretRightOutlined, CheckCircleFilled } from '@ant-design/icons';
import { Collapse, theme, Menu, Button } from 'antd';
import { IoSchoolOutline } from "react-icons/io5";
import { IoPersonAddOutline } from "react-icons/io5";
import { BsCheckCircleFill } from "react-icons/bs";
import axios from '../../services/axiosConfig';
import {Tooltip } from 'antd';
import { MdQuestionMark } from "react-icons/md";

import { IoInformationCircleOutline } from "react-icons/io5";



const Issues = () => {
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const [expandedCard, setExpandedCard] = useState(null);
  const [issueText, setIssueText] = useState('');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [collapseActiveKeys, setCollapseActiveKeys] = useState([]);
  
  // Tab state for the Menu component
  const [currentTab, setCurrentTab] = useState('settings');
  
  // Handle tab change
  const handleTabChange = (e) => {
    setCurrentTab(e.key);
    // Force collapse panels to reset when changing tabs
    setCollapseActiveKeys([]); 
  };

  // Menu items configuration for tabs
  const menuItems = [
    {
      key: 'settings',
      label: (
        <div className="d-flex flex-column align-items-center">
          <VscTools className="icon-size-XL mb-1" />
          <span className ="fw-semibold">{t('general.issues.settings')}</span>
        </div>
      ),
    },
    {
      key: 'user',
      label: (
        <div className="d-flex flex-column align-items-center">
          <IoManOutline className="icon-size-XL mb-1" />
          <span className ="fw-semibold">{t('general.issues.user')}</span>
        </div>
      ),
    },
    {
      key: 'protocol',
      label: (
        <div className="d-flex flex-column align-items-center">
          <IoPersonAddOutline className="icon-size-XL mb-1" />
          <span className ="fw-semibold">{t('general.issues.protocol')}</span>
        </div>
      ),
    },
    {
      key: 'other',
      label: (
        <div className="d-flex flex-column align-items-center">
          <IoPeopleOutline className="icon-size-XL mb-1" />
          <span className ="fw-semibold">{t('general.issues.other')}</span>
        </div>
      ),
    },
    {
      key: 'questionnaire',
      label: (
        <div className="d-flex flex-column align-items-center">
          <BsCardChecklist className="icon-size-XL mb-1" />
          <span className ="fw-semibold">{t('general.issues.questionnaire')}</span>
        </div>
      ),
    },
    // {
    //   key: 'patient',
    //   label: (
    //     <div className="d-flex flex-column align-items-center">
    //       <IoSchoolOutline className="icon-size-XL mb-1" />
    //       <span className ="fw-semibold">{t('general.issues.patient')}</span>
    //     </div>
    //   ),
    // },
    {
      key: 'problem',
      label: (
        <div className="d-flex flex-column align-items-center">
          <MdQuestionMark className="icon-size-XL mb-1" />
          <span className ="fw-semibold">Segnala Problema</span>
        </div>
      ),
    },
  ];

  // FAQ content based on the current tab
  const getFaqContent = () => {
    switch (currentTab) {
      case 'settings':
        return [
          { question: <TransText i18nKey={'FAQ.settings'} />, answer: <TransText i18nKey={'FAQ.answer1'} /> },
          { question: <TransText i18nKey={'FAQ.settings2'} />, answer: <TransText i18nKey={'FAQ.answer2'} /> },
        ];
      case 'user':
        return [
          { question: <TransText i18nKey={'FAQ.userQ1'} />, answer: <TransText i18nKey={'FAQ.userA1'} /> },
          { question: <TransText i18nKey={'FAQ.userQ2'} />, answer: <TransText i18nKey={'FAQ.userA2'} /> },
          { question: <TransText i18nKey={'FAQ.userQ3'} />, answer: <TransText i18nKey={'FAQ.userA3'} /> },
          { question: <TransText i18nKey={'FAQ.userQ4'} />, answer: <TransText i18nKey={'FAQ.userA4'} /> },
          { question: <TransText i18nKey={'FAQ.userQ5'} />, answer: <TransText i18nKey={'FAQ.userA5'} /> },
        ];
      case 'protocol':
        return [
          { question: <TransText i18nKey={'FAQ.newDocQ1'} />, answer: <TransText i18nKey={'FAQ.newDocA1'} /> },
          { question: <TransText i18nKey={'FAQ.newDocQ2'} />, answer: <TransText i18nKey={'FAQ.newDocA2'} /> },
          { question: <TransText i18nKey={'FAQ.newDocQ3'} />, answer: <TransText i18nKey={'FAQ.newDocA3'} /> },
          { question: <TransText i18nKey={'FAQ.newDocQ4'} />, answer: <TransText i18nKey={'FAQ.newDocA4'} /> },
        ];
      case 'other':
        return [
          // { question: <TransText i18nKey={'FAQ.differentUserQ1'} />, answer: <TransText i18nKey={'FAQ.differentUserA1'} /> },
          { question: <TransText i18nKey={'FAQ.differentUserQ2'} />, answer: <TransText i18nKey={'FAQ.differentUserA2'} /> },
          { question: <TransText i18nKey={'FAQ.differentUserQ3'} />, answer: <TransText i18nKey={'FAQ.differentUserA3'} /> },
        ];
      case 'questionnaire':
        return [
          // { question: <TransText i18nKey={'FAQ.patientSummaryQ1'} />, answer: <TransText i18nKey={'FAQ.patientSummaryA1'} /> },
          { question: <TransText i18nKey={'FAQ.patientSummaryQ2'} />, answer: <TransText i18nKey={'FAQ.patientSummaryA2'} /> },
          { question: <TransText i18nKey={'FAQ.patientSummaryQ3'} />, answer: <TransText i18nKey={'FAQ.patientSummaryA3'} /> },
          { question: <TransText i18nKey={'FAQ.sessionQ4'} />, answer: <TransText i18nKey={'FAQ.sessionA4'} /> },
          { question: <TransText i18nKey={'FAQ.sessionQ2'} />, answer: <TransText i18nKey={'FAQ.sessionA2'} /> },
          { question: <TransText i18nKey={'FAQ.patientSummaryQ4'} />, answer: <TransText i18nKey={'FAQ.patientSummaryA4'} /> },
        ];
      // case 'patient':
      //   return [
      //     { question: <TransText i18nKey={'FAQ.sessionQ1'} />, answer: <TransText i18nKey={'FAQ.sessionA1'} /> },
      //     { question: <TransText i18nKey={'FAQ.sessionQ3'} />, answer: <TransText i18nKey={'FAQ.sessionA3'} /> },
      //     { question: <TransText i18nKey={'FAQ.sessionQ5'} />, answer: <TransText i18nKey={'FAQ.sessionA5'} /> },
      //   ];
      case 'problem':
        // For problem tab, return empty array as we'll render a different component
        return [];
      default:
        return [];
    }
  };



  const handleTextChange = (e) => {
    const text = e.target.value;
    setIssueText(text);
    setIsSubmitDisabled(text.trim() === '');
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      await axios.post('/issues/newissues', { text: issueText });
      
      // Show success modal
      setShowSuccessModal(true);
      setIssueText('');
      setIsSubmitDisabled(true);
    } catch (error) {
      console.error("Errore durante l'invio della segnalazione:", error);
      const errorMsg = error.response?.data?.error || t('general.errors.submission') || "Errore durante l'invio della segnalazione. Riprova più tardi.";
      setErrorMessage(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <header  className=" p-3" style={{ backgroundColor: 'var(--second-color-extra-light2)', borderBottom: '1px solid #ddd' }}>
        <div className="d-flex flex-column align-items-center text-center">
          <IoAlert className="color-2 text-white icon-size-settings p-3 mt-1 mb-1 rounded-circle" />
          <h3>{t('general.issues.title')}</h3>
          <div className='mx-5'><div className="fs-6 ms-5 me-5"><TransText i18nKey='general.issues.text' /></div></div>
        </div>
      </header>

      <div className="container-xxl">
        {/* <div className="text-center mb-2 d-flex justify-content-center align-items-center mt-2 gap-2">
          <h3 className=" fw-semibold mb-0"><TransText i18nKey='general.issues.faq' /></h3>
          <Tooltip
            title={<span className="fs-6"><TransText i18nKey='general.issues.faqDescription' /></span>}
            trigger={["click"]}
            placement="right"
            color={'blue'}
            open={tooltipVisible}
            onOpenChange={setTooltipVisible}
          >
            <span
              className="d-flex justify-content-center align-items-end icon-cursor"
              onClick={() => setTooltipVisible(!tooltipVisible)}
            >
              <IoInformationCircleOutline className="icon-size-XL" />
            </span>
          </Tooltip>
        </div> */}
        
        {/* Tabbed menu navigation */}
        <div className="mb-4 mt-4 d-flex justify-content-center">
          <Menu 
            onClick={handleTabChange} 
            selectedKeys={[currentTab]} 
            mode="horizontal" 
            items={menuItems} 
            className="fs-5 d-flex justify-content-center w-100"
            style={{ background: 'transparent' }}
          />
        </div>

        {/* Accordion for FAQ content */}
        {currentTab !== 'problem' ? (
          <Row className="justify-content-center mb-4">
            <Col md={10} lg={10} xl={9}>
              <Collapse
                bordered={false}
                // expandIcon={({ isActive }) => (
                //   <CaretRightOutlined rotate={isActive ? 90 : 0} />
                // )}
                style={{ background: 'transparent' }}
                expandIconPosition="end"
                activeKey={collapseActiveKeys}
                onChange={(keys) => setCollapseActiveKeys(keys)}
              >
                {getFaqContent().map((item, index) => (
                  <Collapse.Panel
                    key={index}
                    header={
                      <span className="fw-semibold fs-6">{item.question}</span>
                    }
                  >
                    <div className="fs-6 ps-3">
                      {item.answer}
                    </div>
                  </Collapse.Panel>
                ))}
              </Collapse>
            </Col>
          </Row>
        ) : (
          <Row className="justify-content-center mb-4">
            <Col md={10} lg={10} xl={9}>
                <span className="fs-6 fw-semibold d-block">
                  {t('general.issues.more')}
                </span>
                <div className="mt-2">
                  <textarea
                    placeholder={t('general.issues.moreText')}
                    className="w-100 p-2 text-M"
                    value={issueText}
                    onChange={handleTextChange}
                    disabled={isLoading}
                    rows={5}
                  />

                  {errorMessage && (
                    <div className="text-danger mt-2 mb-2 text-center">
                      {errorMessage}
                    </div>
                  )}
                  <div className="d-flex justify-content-center mt-3">
                    <Button
                      className='button-responsive fs-5 button-color'
                      type='primary'
                      onClick={handleSubmit}
                      disabled={isSubmitDisabled || isLoading}
                      loading={isLoading}
                    >
                      {t('general.actions.send')}
                    </Button>
                  </div>
                </div>
            </Col>
          </Row>
        )}


      </div>

      {/* Success Modal */}
      <Modal show={showSuccessModal} centered>
        <Modal.Header>
          <Modal.Title>
            <span className="d-flex align-items-center">
              <span className="me-2"><CheckCircleFilled className="icon-size-XL icon-success" /></span>
              <TransText i18nKey="general.issues.moreSendTitle" />
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className='fs-6'>
            <TransText i18nKey="general.issues.moreSend" />
          </span>
          <div className="d-flex justify-content-end mt-2">
            <Button 
              variant="primary" 
              className="button-color fs-5 button-responsive text-white" 
              onClick={() => setShowSuccessModal(false)}
            >
              <TransText i18nKey="general.issues.moreNew" />
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Issues;